{
  "labels": {
    "paste": "Prilepi",
    "pasteAsPlaintext": "Prilepi kot navadno besedilo",
    "pasteCharts": "Prilepi grafikone",
    "selectAll": "Izberi vse",
    "multiSelect": "Dodaj element v izbor",
    "moveCanvas": "Premakni platno",
    "cut": "Izreži",
    "copy": "Kopiraj",
    "copyAsPng": "Kopiraj v odložišče kot PNG",
    "copyAsSvg": "Kopiraj v odložišče kot SVG",
    "copyText": "Kopiraj v odložišče kot besedilo",
    "copySource": "Kopiraj vir v odložišče",
    "convertToCode": "Pretvori v kodo",
    "bringForward": "Postavi naprej",
    "sendToBack": "Pomakni v ozadje",
    "bringToFront": "Pomakni v ospredje",
    "sendBackward": "Pošlji nazaj",
    "delete": "Izbriši",
    "copyStyles": "Kopiraj slog",
    "pasteStyles": "Prilepi slog",
    "stroke": "Poteza",
    "background": "Ozadje",
    "fill": "Polnilo",
    "strokeWidth": "Debelina poteze",
    "strokeStyle": "Slog poteze",
    "strokeStyle_solid": "Polna",
    "strokeStyle_dashed": "Črtkana",
    "strokeStyle_dotted": "Pikasta",
    "sloppiness": "Površnost",
    "opacity": "Prekrivnost",
    "textAlign": "Poravnava besedila",
    "edges": "Robovi",
    "sharp": "Ostri",
    "round": "Okrogli",
    "arrowheads": "Puščice",
    "arrowhead_none": "Brez",
    "arrowhead_arrow": "Puščica",
    "arrowhead_bar": "Palica",
    "arrowhead_circle": "Krog",
    "arrowhead_circle_outline": "Krog (oris)",
    "arrowhead_triangle": "Trikotnik",
    "arrowhead_triangle_outline": "Trikotnik (oris)",
    "arrowhead_diamond": "Diamant",
    "arrowhead_diamond_outline": "Diamant (oris)",
    "fontSize": "Velikost pisave",
    "fontFamily": "Družina pisave",
    "addWatermark": "Dodaj \"Izdelano z Excalidraw\"",
    "handDrawn": "Ročno narisano",
    "normal": "Običajno",
    "code": "Koda",
    "small": "Majhna",
    "medium": "Srednja",
    "large": "Velika",
    "veryLarge": "Zelo velika",
    "solid": "Polno",
    "hachure": "Šrafura",
    "zigzag": "Cikcak",
    "crossHatch": "Križno",
    "thin": "Tanko",
    "bold": "Krepko",
    "left": "Levo",
    "center": "Sredina",
    "right": "Desno",
    "extraBold": "Ekstra krepko",
    "architect": "Arhitekt",
    "artist": "Umetnik",
    "cartoonist": "Risar",
    "fileTitle": "Ime datoteke",
    "colorPicker": "Izbor barve",
    "canvasColors": "Uporabljeno na platnu",
    "canvasBackground": "Ozadje platna",
    "drawingCanvas": "Platno za risanje",
    "layers": "Plasti",
    "actions": "Dejanja",
    "language": "Jezik",
    "liveCollaboration": "Sodelovanje v živo...",
    "duplicateSelection": "Podvoji",
    "untitled": "Neimenovana",
    "name": "Ime",
    "yourName": "Vaše ime",
    "madeWithExcalidraw": "Izdelano z Excalidraw",
    "group": "Združi izbor",
    "ungroup": "Razdruži izbor",
    "collaborators": "Sodelavci",
    "showGrid": "Prikaži mrežo",
    "addToLibrary": "Dodaj v knjižnico",
    "removeFromLibrary": "Odstrani iz knjižnice",
    "libraryLoadingMessage": "Nalaganje knjižnice ...",
    "libraries": "Brskaj po knjižnicah",
    "loadingScene": "Nalaganje scene...",
    "align": "Poravnava",
    "alignTop": "Poravnaj na vrh",
    "alignBottom": "Poravnaj na dno",
    "alignLeft": "Poravnaj levo",
    "alignRight": "Poravnaj desno",
    "centerVertically": "Navpično na sredini",
    "centerHorizontally": "Vodoravno na sredini",
    "distributeHorizontally": "Porazdeli vodoravno",
    "distributeVertically": "Porazdeli navpično",
    "flipHorizontal": "Obrni vodoravno",
    "flipVertical": "Obrni navpično",
    "viewMode": "Način ogleda",
    "share": "Deli",
    "showStroke": "Prikaži izbirnik barv poteze",
    "showBackground": "Prikaži izbirnik barv ozadja",
    "toggleTheme": "Obrni temo",
    "personalLib": "Osebna knjižnica",
    "excalidrawLib": "Knjižnica Excalidraw",
    "decreaseFontSize": "Zmanjšaj velikost pisave",
    "increaseFontSize": "Povečaj velikost pisave",
    "unbindText": "Veži besedilo",
    "bindText": "Veži besedilo na element",
    "createContainerFromText": "Zavij besedilo v vsebnik",
    "link": {
      "edit": "Uredi povezavo",
      "editEmbed": "Uredi povezavo in vdelaj",
      "create": "Ustvari povezavo",
      "createEmbed": "Ustvari povezavo in vdelaj",
      "label": "Povezava",
      "labelEmbed": "Povezava in vdelovanje",
      "empty": "Povezava ni nastavljena"
    },
    "lineEditor": {
      "edit": "Uredi črto",
      "exit": "Zapri urejanje črte"
    },
    "elementLock": {
      "lock": "Zakleni",
      "unlock": "Odkleni",
      "lockAll": "Zakleni vse",
      "unlockAll": "Odkleni vse"
    },
    "statusPublished": "Objavljeno",
    "sidebarLock": "Obdrži stransko vrstico odprto",
    "selectAllElementsInFrame": "Izberi vse elemente v okvirju",
    "removeAllElementsFromFrame": "Izbriši vse elemente v okvirju",
    "eyeDropper": "Izberi barvo s platna",
    "textToDiagram": "Besedilo v diagram",
    "prompt": "Poziv"
  },
  "library": {
    "noItems": "Dodan še ni noben element...",
    "hint_emptyLibrary": "Izberite element na platnu, da ga dodate sem, ali namestite knjižnico iz javnega skladišča spodaj.",
    "hint_emptyPrivateLibrary": "Izberite element na platnu, da ga dodate sem."
  },
  "buttons": {
    "clearReset": "Ponastavi platno",
    "exportJSON": "Izvozi v datoteko",
    "exportImage": "Izvozi sliko...",
    "export": "Shrani v...",
    "copyToClipboard": "Kopiraj v odložišče",
    "save": "Shrani v trenutno datoteko",
    "saveAs": "Shrani kot",
    "load": "Odpri",
    "getShareableLink": "Pridobi povezavo za deljenje",
    "close": "Zapri",
    "selectLanguage": "Izberi jezik",
    "scrollBackToContent": "Pomakni se nazaj na vsebino",
    "zoomIn": "Povečaj",
    "zoomOut": "Pomanjšaj",
    "resetZoom": "Ponastavi povečavo",
    "menu": "Meni",
    "done": "Končano",
    "edit": "Uredi",
    "undo": "Razveljavi",
    "redo": "Ponovi",
    "resetLibrary": "Ponastavi knjižnico",
    "createNewRoom": "Ustvari novo sobo",
    "fullScreen": "Celozaslonski način",
    "darkMode": "Temni način",
    "lightMode": "Svetli način",
    "zenMode": "Način Zen",
    "objectsSnapMode": "Pripenjanje na predmete",
    "exitZenMode": "Zapri način Zen",
    "cancel": "Prekliči",
    "clear": "Počisti",
    "remove": "Odstrani",
    "embed": "Preklopi vdelavo",
    "publishLibrary": "Objavi",
    "submit": "Pošlji",
    "confirm": "Potrdi",
    "embeddableInteractionButton": "Kliknite za interakcijo"
  },
  "alerts": {
    "clearReset": "To bo počistilo celotno platno. Ali ste prepričani?",
    "couldNotCreateShareableLink": "Povezave za deljenje ni bilo mogoče ustvariti.",
    "couldNotCreateShareableLinkTooBig": "Povezave za deljenje ni bilo mogoče ustvariti: scena je prevelika",
    "couldNotLoadInvalidFile": "Neveljavne datoteke ni bilo mogoče naložiti",
    "importBackendFailed": "Uvoz iz zaledja ni uspel.",
    "cannotExportEmptyCanvas": "Izvoz prazne scene ni mogoč.",
    "couldNotCopyToClipboard": "Kopiranje v odložišče ni uspelo.",
    "decryptFailed": "Dešifriranje podatkov ni uspelo.",
    "uploadedSecurly": "Nalaganje je bilo zaščiteno s šifriranjem od konca do konca, kar pomeni, da strežnik Excalidraw in tretje osebe ne morejo brati vsebine.",
    "loadSceneOverridePrompt": "Nalaganje zunanje risbe bo nadomestilo vašo obstoječo vsebino. Ali želite nadaljevati?",
    "collabStopOverridePrompt": "Ustavitev seje bo prepisala vašo prejšnjo, lokalno shranjeno risbo. Ali ste prepričani?\n\n(Če želite obdržati lokalno risbo, preprosto zaprite zavihek brskalnika.)",
    "errorAddingToLibrary": "Elementa ni bilo mogoče dodati v knjižnico",
    "errorRemovingFromLibrary": "Elementa ni bilo mogoče izbrisati iz knjižnice",
    "confirmAddLibrary": "S tem boste v vašo knjižnico dodali oblike ({{numShapes}}). Ali ste prepričani?",
    "imageDoesNotContainScene": "Zdi se, da ta slika ne vsebuje podatkov o sceni. Ali ste med izvozom omogočili vdelavo scene?",
    "cannotRestoreFromImage": "Scene ni bilo mogoče obnoviti iz te slikovne datoteke",
    "invalidSceneUrl": "S priloženega URL-ja ni bilo mogoče uvoziti scene. Je napačno oblikovana ali pa ne vsebuje veljavnih podatkov Excalidraw JSON.",
    "resetLibrary": "To bo počistilo vašo knjižnico. Ali ste prepričani?",
    "removeItemsFromsLibrary": "Izbriši elemente ({{count}}) iz knjižnice?",
    "invalidEncryptionKey": "Ključ za šifriranje mora vsebovati 22 znakov. Sodelovanje v živo je onemogočeno.",
    "collabOfflineWarning": "Internetna povezava ni na voljo.\nVaše spremembe ne bodo shranjene!"
  },
  "errors": {
    "unsupportedFileType": "Nepodprt tip datoteke.",
    "imageInsertError": "Vstavljanje slike ni bilo uspešno. Poskusite ponovno kasneje...",
    "fileTooBig": "Datoteka je prevelika. Največja dovoljena velikost je {{maxSize}}.",
    "svgImageInsertError": "Vstavljanje slike SVG ni uspelo. Oznake SVG so videti neveljavne.",
    "failedToFetchImage": "Pridobivanje slike ni uspelo.",
    "invalidSVGString": "Neveljaven SVG.",
    "cannotResolveCollabServer": "Povezave s strežnikom za sodelovanje ni bilo mogoče vzpostaviti. Ponovno naložite stran in poskusite znova.",
    "importLibraryError": "Nalaganje knjižnice ni uspelo",
    "collabSaveFailed": "Ni bilo mogoče shraniti v zaledno bazo podatkov. Če se težave nadaljujejo, shranite datoteko lokalno, da ne boste izgubili svojega dela.",
    "collabSaveFailed_sizeExceeded": "Ni bilo mogoče shraniti v zaledno bazo podatkov, zdi se, da je platno preveliko. Datoteko shranite lokalno, da ne izgubite svojega dela.",
    "imageToolNotSupported": "Slike so onemogočene.",
    "brave_measure_text_error": {
      "line1": "Videti je, da uporabljate brskalnik Brave z omogočeno nastavitvijo <bold>Agresivno blokiranje prstnih odtisov</bold>.",
      "line2": "To bi lahko povzročilo motnje v obnašanju <bold>besedilnih elementov</bold> v vaših risbah.",
      "line3": "Močno priporočamo, da onemogočite to nastavitev. Sledite <link>tem korakom</link>, kako to storiti.",
      "line4": "Če onemogočanje te nastavitve ne popravi prikaza besedilnih elementov, odprite <issueLink>vprašanje</issueLink> na našem GitHubu ali nam pišite na <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Vdelani elementi ne morejo biti dodani v knjižnico.",
      "iframe": "Elementov iFrame ni mogoče dodati v knjižnico.",
      "image": "Podpora za dodajanje slik v knjižnico prihaja kmalu!"
    },
    "asyncPasteFailedOnRead": "Ni bilo mogoče prilepiti (ni bilo mogoče brati iz sistemskega odložišča).",
    "asyncPasteFailedOnParse": "Ni bilo mogoče prilepiti.",
    "copyToSystemClipboardFailed": "Ni bilo mogoče kopirati v odložišče."
  },
  "toolBar": {
    "selection": "Izbor",
    "image": "Vstavi sliko",
    "rectangle": "Pravokotnik",
    "diamond": "Diamant",
    "ellipse": "Elipsa",
    "arrow": "Puščica",
    "line": "Črta",
    "freedraw": "Risanje",
    "text": "Besedilo",
    "library": "Knjižnica",
    "lock": "Ohrani izbrano orodje aktivno po risanju",
    "penMode": "Način peresa - prepreči dotik",
    "link": "Dodaj/posodobi povezavo za izbrano obliko",
    "eraser": "Radirka",
    "frame": "Okvir",
    "magicframe": "Žični okvir v kodo",
    "embeddable": "Spletna vdelava",
    "laser": "Laserski kazalec",
    "hand": "Roka (orodje za premikanje)",
    "extraTools": "Več orodij",
    "mermaidToExcalidraw": "Mermaid v Excalidraw",
    "magicSettings": "Nastavitve AI"
  },
  "headings": {
    "canvasActions": "Dejanja za platno",
    "selectedShapeActions": "Dejanja za izbrane oblike",
    "shapes": "Oblike"
  },
  "hints": {
    "canvasPanning": "Za premikanje platna med vlečenjem držite kolesce miške ali preslednico ali uporabite orodje roka",
    "linearElement": "Kliknite za začetek več točk, povlecite za posamezno črto",
    "freeDraw": "Kliknite in povlecite, spustite, ko končate",
    "text": "Namig: besedilo lahko dodate tudi z dvoklikom kjer koli z orodjem za izbiro",
    "embeddable": "Kliknite in povlecite, da ustvarite spletno vdelavo",
    "text_selected": "Dvokliknite ali pritisnite tipko Enter, da uredite besedilo",
    "text_editing": "Pritisnite tipko Escape ali CtrlOrCmd+Enter za zaključek urejanja",
    "linearElementMulti": "Kliknite zadnjo točko ali pritisnite Escape ali Enter, da končate",
    "lockAngle": "Kot lahko omejite tako, da držite tipko Shift",
    "resize": "Razmerja lahko omejite tako, da držite tipko Shift med spreminjanjem velikosti. Držite tipko Alt, da spremenite velikost od središča",
    "resizeImage": "Velikost lahko prosto spreminjate tako, da držite tipko Shift. Držite tipko Alt, da spremenite velikost od središča",
    "rotate": "Kote lahko omejite tako, da med vrtenjem držite tipko Shift",
    "lineEditor_info": "Držite CtrlOrCmd in dvokliknite ali pritisnite CtrlOrCmd + Enter za urejanje točk",
    "lineEditor_pointSelected": "Pritisnite tipko Delete, da odstranite točko(e), CtrlOrCmd+D za podvojitev ali povlecite za premikanje",
    "lineEditor_nothingSelected": "Izberite točko za urejanje (pridržite tipko Shift za izbiro več točk), ali držite tipko Alt in kliknite za dodajanje novih točk",
    "placeImage": "Kliknite, da postavite sliko, ali kliknite in povlecite, da ročno nastavite njeno velikost",
    "publishLibrary": "Objavi svojo knjižnico",
    "bindTextToElement": "Pritisnite tipko Enter za dodajanje besedila",
    "deepBoxSelect": "Držite tipko CtrlOrCmd za globoko izbiro in preprečitev vlečenja",
    "eraserRevert": "Pridržite tipko Alt, da razveljavite elemente, označene za brisanje",
    "firefox_clipboard_write": "To funkcijo lahko verjetno omogočite z nastavitvijo zastavice \"dom.events.asyncClipboard.clipboardItem\" na \"true\". Če želite spremeniti zastavice brskalnika v Firefoxu, obiščite stran \"about:config\".",
    "disableSnapping": "Držite CtrlOrCmd, da onemogočite pripenjanje"
  },
  "canvasError": {
    "cannotShowPreview": "Predogleda ni bilo mogoče prikazati",
    "canvasTooBig": "Morda je platno preveliko.",
    "canvasTooBigTip": "Nasvet: poskusite premakniti najbolj oddaljene elemente nekoliko bližje skupaj."
  },
  "errorSplash": {
    "headingMain": "Prišlo je do napake. Poskusite <button>ponovno naložiti stran.</button>",
    "clearCanvasMessage": "Če ponovno nalaganje ne deluje, poskusite <button>počistiti platno.</button>",
    "clearCanvasCaveat": " To bo povzročilo izgubo dela ",
    "trackedToSentry": "Napaka z identifikatorjem {{eventId}} smo zabeležili v naš sistem.",
    "openIssueMessage": "Zelo smo bili previdni, da v podatke o napaki nismo vključili vaših podatkov o sceni. Če vaša scena ni zasebna, vas prosimo, da napišete več podrobnosti na našem <button>sledilniku hroščev.</button> Prosimo, vključite spodnje informacije tako, da jih kopirate in prilepite v GitHub vprašanje.",
    "sceneContent": "Vsebina scene:"
  },
  "roomDialog": {
    "desc_intro": "Na vašo trenutno sceno lahko povabite osebe, ki bodo sodelovale z vami.",
    "desc_privacy": "Brez skrbi. Seja uporablja šifriranje od konca do konca, tako da bo vse, kar narišete, ostalo zasebno. Niti naš strežnik ne bo mogel videti, kaj si izmislite.",
    "button_startSession": "Začni sejo",
    "button_stopSession": "Ustavi sejo",
    "desc_inProgressIntro": "Seja sodelovanja v živo je v teku.",
    "desc_shareLink": "Delite to povezavo z vsemi, s katerimi želite sodelovati:",
    "desc_exitSession": "Ustavitev seje vas bo odklopila od sobe, vendar boste lahko lokalno nadaljevali delo s sceno. To pa ne bo vplivalo na druge osebe. Druge osebe bodo še vedno lahko sodelovale v svoji različici.",
    "shareTitle": "Pridruži se seji sodelovanja v živo na Excalidraw"
  },
  "errorDialog": {
    "title": "Napaka"
  },
  "exportDialog": {
    "disk_title": "Shrani na disk",
    "disk_details": "Izvozite podatke scene v datoteko, iz katere jo lahko pozneje uvozite.",
    "disk_button": "Shrani v datoteko",
    "link_title": "Povezava za deljenje",
    "link_details": "Izvoz kot povezava samo za branje.",
    "link_button": "Izvoz kot povezava",
    "excalidrawplus_description": "Shrani sceno v svoj delovni prostor Excalidraw+.",
    "excalidrawplus_button": "Izvoz",
    "excalidrawplus_exportError": "Trenutno ni bilo mogoče izvoziti v Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Preberite naš blog",
    "click": "klik",
    "deepSelect": "Globoka izbira",
    "deepBoxSelect": "Globoka izbira znotraj polja in preprečitev vlečenja",
    "curvedArrow": "Ukrivljena puščica",
    "curvedLine": "Ukrivljena črta",
    "documentation": "Dokumentacija",
    "doubleClick": "dvojni klik",
    "drag": "vleci",
    "editor": "Urejevalnik",
    "editLineArrowPoints": "Uredi črto/točke puščice",
    "editText": "Uredi besedilo / dodaj oznako",
    "github": "Ste našli težavo? Pošljite",
    "howto": "Sledite našim vodičem",
    "or": "ali",
    "preventBinding": "Prepreči vezanje puščice",
    "tools": "Orodja",
    "shortcuts": "Bližnjice na tipkovnici",
    "textFinish": "Zaključi urejanje (urejevalnik besedila)",
    "textNewLine": "Dodaj novo vrstico (urejevalnik besedila)",
    "title": "Pomoč",
    "view": "Pogled",
    "zoomToFit": "Približaj na vse elemente",
    "zoomToSelection": "Približaj na izbor",
    "toggleElementLock": "Zakleni/odkleni izbor",
    "movePageUpDown": "Premakni stran gor/dol",
    "movePageLeftRight": "Premakni stran levo/desno"
  },
  "clearCanvasDialog": {
    "title": "Počisti platno"
  },
  "publishDialog": {
    "title": "Objavi knjižnico",
    "itemName": "Ime elementa",
    "authorName": "Ime avtorja",
    "githubUsername": "GitHub uporabniško ime",
    "twitterUsername": "Twitter uporabniško ime",
    "libraryName": "Ime knjižnice",
    "libraryDesc": "Opis knijžnice",
    "website": "Spletna stran",
    "placeholder": {
      "authorName": "Vaše ime ali uporabniško ime",
      "libraryName": "Ime vaše knjižnice",
      "libraryDesc": "Opis vaše knjižnice, da bodo ljudje lažje razumeli njeno uporabo",
      "githubHandle": "GitHub uporabniško ime (neobvezno), tako da lahko urejate knjižnico potem, ko jo pošljete v pregled",
      "twitterHandle": "Twitter uporabniško ime (neobvezno), tako da vemo, koga omeniti pri promociji prek Twitterja",
      "website": "Povezava na vašo osebno spletno stran ali drugam (neobvezno)"
    },
    "errors": {
      "required": "Obvezno",
      "website": "Vnesite veljaven URL"
    },
    "noteDescription": "Predložite svojo knjižnico, da bo vključena v <link>javno skladišče knjižnic,</link>da jih drugi lahko uporabljajo v svojih risbah.",
    "noteGuidelines": "Knjižnica mora biti najprej ročno odobrena. Prosimo vas, da pred oddajanjem preberete naše <link>smernice.</link>Za komunikacijo in spreminjanje po potrebi boste potrebovali račun GitHub, vendar to ni obvezno.",
    "noteLicense": "Z oddajo se strinjate, da bo knjižnica objavljena pod <link>licenco MIT, </link>kar na kratko pomeni, da jo lahko kdorkoli uporablja brez omejitev.",
    "noteItems": "Vsak element knjižnice mora imeti svoje ime, tako da ga je mogoče filtrirati. Vključeni bodo naslednji elementi knjižnice:",
    "atleastOneLibItem": "Za začetek izberite vsaj en element knjižnice",
    "republishWarning": "Opomba: nekateri izbrani predmeti so označeni kot že objavljeni/oddani. Elemente lahko znova oddate samo, ko posodabljate obstoječo knjižnico ali oddajo."
  },
  "publishSuccessDialog": {
    "title": "Knjižnica oddana",
    "content": "{{authorName}}, hvala. Vaša knjižnica je bila poslana v pregled. Stanje lahko spremljate<link>tukaj</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Ponastavi knjižnico",
    "removeItemsFromLib": "Odstran izbrane elemente iz knjižnice"
  },
  "imageExportDialog": {
    "header": "Izvozi sliko",
    "label": {
      "withBackground": "Ozadje",
      "onlySelected": "Samo izbor",
      "darkMode": "Temni način",
      "embedScene": "Vdelaj sceno",
      "scale": "Povečava",
      "padding": "Odmik"
    },
    "tooltip": {
      "embedScene": "Podatki o sceni bodo shranjeni v izvoženo datoteko PNG/SVG, tako da bo sceno mogoče obnoviti iz nje.\nTo bo povečalo velikost izvožene datoteke."
    },
    "title": {
      "exportToPng": "Izvozi v PNG",
      "exportToSvg": "Izvozi v SVG",
      "copyPngToClipboard": "Kopiraj PNG v odložišče"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopiraj v odložišče"
    }
  },
  "encrypted": {
    "tooltip": "Vaše risbe so šifrirane od konca do konca, tako da jih strežniki Excalidraw nikoli ne bodo videli.",
    "link": "Blog objava o šifriranju od konca do konca v Excalidraw"
  },
  "stats": {
    "angle": "Kot",
    "element": "Element",
    "elements": "Elementi",
    "height": "Višina",
    "scene": "Scena",
    "selected": "Izbrano",
    "storage": "Shramba",
    "title": "Statistika za napredne uporabnike",
    "total": "Skupaj",
    "version": "Različica",
    "versionCopy": "Kliknite za kopiranje",
    "versionNotAvailable": "Različica ni na voljo",
    "width": "Širina"
  },
  "toast": {
    "addedToLibrary": "Dodano v knjižnico",
    "copyStyles": "Slogi kopirani.",
    "copyToClipboard": "Kopirano v odložišče.",
    "copyToClipboardAsPng": "Kopirano v odložišče kot PNG ({{exportSelection}}, {{exportColorScheme}})",
    "fileSaved": "Datoteka shranjena.",
    "fileSavedToFilename": "Shranjeno v {filename}",
    "canvas": "platno",
    "selection": "izbor",
    "pasteAsSingleElement": "Uporabite {{shortcut}}, da prilepite kot en element,\n ali prilepite v obstoječ urejevalnik besedil",
    "unableToEmbed": "Vdelava tega URL-ja trenutno ni dovoljena. Ustvarite vprašanje na GitHub-u in prosite za vmestitev URL-ja na seznam dovoljenih",
    "unrecognizedLinkFormat": "Povezava, ki ste jo vdelali, se ne ujema s pričakovano obliko. Poskusite prilepiti niz za vdelavo, ki ste ga prejeli na izvorni strani"
  },
  "colors": {
    "transparent": "Prosojno",
    "black": "Črna",
    "white": "Bela",
    "red": "Rdeča",
    "pink": "Roza",
    "grape": "Grozdje",
    "violet": "Vijolična",
    "gray": "Siva",
    "blue": "Modra",
    "cyan": "Cijan",
    "teal": "Turkizna",
    "green": "Zelena",
    "yellow": "Rumena",
    "orange": "Oranžna",
    "bronze": "Bronasta"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Vsi vaši podatki so shranjeni lokalno v vašem brskalniku.",
      "center_heading_plus": "Ste namesto tega želeli odpreti Excalidraw+?",
      "menuHint": "Izvoz, nastavitve, jeziki, ..."
    },
    "defaults": {
      "menuHint": "Izvoz, nastavitve in več ...",
      "center_heading": "Diagrami. Enostavno.",
      "toolbarHint": "Izberi orodje in začni z risanjem!",
      "helpHint": "Bližnjice in pomoč"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Najpogosteje uporabljene barve po meri",
    "colors": "Barve",
    "shades": "Odtenki",
    "hexCode": "Hex koda",
    "noShades": "Odtenki za to barvo niso na voljo"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Izvozi kot sliko",
        "button": "Izvozi kot sliko",
        "description": "Izvozite podatke scene kot sliko, iz katere jo lahko pozneje uvozite."
      },
      "saveToDisk": {
        "title": "Shrani na disk",
        "button": "Shrani na disk",
        "description": "Izvozite podatke scene v datoteko, iz katere jo lahko pozneje uvozite."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Izvozi v Excalidraw+",
        "description": "Shrani sceno v svoj delovni prostor Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Naloži iz datoteke",
        "button": "Naloži iz datoteke",
        "description": "Nalaganje iz datoteke bo <bold>prepisalo vašo obstoječo vsebino</bold>.<br></br>Svojo risbo lahko najprej varnostno kopirate z eno od spodnjih možnosti."
      },
      "shareableLink": {
        "title": "Naloži iz povezave",
        "button": "Zamenjaj mojo vsebino",
        "description": "Nalaganje zunanje risbe bo <bold>prepisalo vašo obstoječo vsebino</bold>.<br></br>Svojo risbo lahko najprej varnostno kopirate z eno od spodnjih možnosti."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid v Excalidraw",
    "button": "Vstavi",
    "description": "Trenutno so podprti samo <flowchartLink>diagrami poteka</flowchartLink>, <sequenceLink>diagrami zaporedij</sequenceLink> in <classLink>Razredni diagrami</classLink>. Druge vrste bodo upodobljene kot slike v Excalidraw.",
    "syntax": "Sintaksa Mermaid",
    "preview": "Predogled"
  }
}
